import styled from "styled-components";

export const Ul = styled.ul`
  padding: 0;
  margin: 0 0 0 10px;
`;
